<template>
  <div class="base-tree" :style="treeStyle">
    <div v-if="$slots.header" class="base-tree__header" :class="[$slots.header ? headerClass : '']">
      <slot name="header" />
    </div>
    <div v-if="treeTitle" class="base-tree__header">{{ treeTitle }}</div>
    <div class="base-tree__content">
      <slot name="content">
        <el-tree
          ref="tree"
          :data="treeData"
          :props="treeDefaultProps"
          :indent="indent"
          :node-key="nodeKey"
          :default-expand-all="defaultExpandAll"
          :highlight-current="highlight"
          :expand-on-click-node="false"
          v-bind="$attrs"
          v-on="$listeners"
        >
          <span slot-scope="{ data, node }" class="custom-tree-node">
            <span class="el-tree-node__label" :style="treeNodeStyle(node)">{{ data[treeDefaultProps.label] }}</span>
            <el-dropdown v-if="isSetting && !data.disabled" @command="handleActionCommand($event, data, node)">
              <i class="el-icon-more" />
              <el-dropdown-menu slot="dropdown" :append-to-body="false">
                <slot name="dropdown" :data="data" :node="node">
                  <el-dropdown-item
                    v-for="{ command, name } in dropDown"
                    :key="command"
                    :command="command"
                  >
                    {{ name }}
                  </el-dropdown-item>
                </slot>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </el-tree>
      </slot>
    </div>
  </div>
</template>

<script>
import { pxToRem } from '@/utils'
import { isFunction } from 'lodash'
import * as api from '@/api/common'
export default {
  name: 'BaseTree',
  props: {
    treeTitle: {
      type: String,
      default: ''
    },
    isSetting: {
      type: Boolean,
      default: true
    },
    width: {
      type: [Number, String],
      default: '300px'
    },
    indent: {
      type: Number,
      default: 16
    },
    nodeKey: {
      type: String,
      default: 'id'
    },
    treeDefaultProps: {
      type: Object,
      default: () => ({
        children: 'child',
        label: 'name'
      })
    },
    dropDown: {
      type: Array,
      default: () => [
        { command: 'main', name: '添加分类' },
        { command: 'sub', name: '添加子分类' },
        { command: 'delete', name: '删除' }
      ]
    },
    apiParams: {
      type: Object,
      default: () => ({})
    },
    dataFromOut: {
      type: Boolean,
      default: false
    },
    outData: {
      type: Array,
      default: () => []
    },
    resultTransformFn: {
      type: Function,
      default: (result) => result
    },
    headerClass: {
      type: String,
      default: ''
    },
    currentKey: {
      type: [String, Number],
      default: ''
    },
    highlight: {
      type: Boolean,
      default: true
    },
    defaultExpandAll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      treeList: []
    }
  },
  computed: {
    treeData: {
      get() {
        const { dataFromOut } = this
        if (dataFromOut) {
          return this.outData
        }
        return this.treeList
      },
      set(val) {
        this.treeList = val
      }
    },
    treeStyle() {
      return {
        width: pxToRem(this.width)
      }
    },
    treeNodeStyle() {
      return (node) => {
        const diff = this.isSetting ? 66 : 46
        return {
          width: pxToRem(parseInt(this.width) - (node.level - 1) * this.indent - diff)
        }
      }
    }
  },
  watch: {
    apiParams: {
      handler() {
        this.getTreeData()
      },
      deep: true
    },
    currentKey(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(val)
        })
      }
    }
  },
  created() {
    if (!this.dataFromOut) {
      this.getTreeData()
    }
  },
  methods: {
    async getTreeData() {
      if (!this.apiParams.url) {
        return
      }
      const params = {}
      const { isSuccess, data } = await api.getAction({
        url: this.apiParams.url,
        params
      })
      if (isSuccess) {
        if (isFunction(this.resultTransformFn)) {
          this.treeData = this.resultTransformFn(data.list)
        } else {
          this.treeData = data.list
        }
        this.$emit('finish', this.treeData)
      } else {
        this.treeData = []
      }
    },
    handleActionCommand(command, data, node) {
      this.$emit('command', command, data, node)
    }
  }
}
</script>

<style lang="scss" scoped>
.base-tree {
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--button-border-color);
  flex-shrink: 0;
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    padding-right: 10px;
    border-bottom: 1px solid var(--button-border-color);
    font-size: 15px;
    color: var(--bread-crumb-no-redirect);
    flex-shrink: 0;
  }
  &__content {
    flex: 1;
    overflow-y: auto;
  }
  ::v-deep .el-tree-node > .el-tree-node__children {
    overflow: initial;
  }
  .custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    margin-right: 10px;
    &:hover .el-dropdown {
      display: block;
    }
    .el-tree-node__label {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .el-dropdown {
      display: none;
      ::v-deep .el-popper {
        margin-top: -5px !important;
      }
    }
  }
}
</style>
